module.exports = __webpack_public_path__ + "img/2_8.11b8a2f7.png";